import { LogInIcon, UserIcon } from 'lucide-react';

import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/hooks/use-auth';
import { ProfileMenu } from '@/components/layout/profile-menu';

/**
 * Compact header auth control for the public site.
 * - Disabled auth: shows a local-dev badge.
 * - Signed out: shows a Sign in button.
 * - Signed in: renders the shared role-aware ProfileMenu (identical to the
 *   staff workspace header).
 *
 * Disabled while MSAL is interacting so double-clicks cannot stack redirects.
 */
export function UserMenu() {
  const { enabled, ready, isAuthenticated, login } = useAuth();

  if (!enabled) {
    return (
      <Badge variant="outline" className="text-muted-foreground gap-1.5">
        <UserIcon className="size-3" />
        Local dev — unauthenticated
      </Badge>
    );
  }

  if (!isAuthenticated) {
    return (
      <Button size="sm" onClick={login} disabled={!ready}>
        <LogInIcon /> Sign in
      </Button>
    );
  }

  // Signed in — delegate to the shared profile menu used in both headers.
  return <ProfileMenu />;
}
